import * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StudentAssignmentsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.StudentAssignmentFilterInput>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.StudentAssignmentSortInput>> | Types.InputMaybe<Types.StudentAssignmentSortInput>>;
}>;


export type StudentAssignmentsQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', studentAssignments: { __typename?: 'PageOfStudentAssignment', results?: Array<{ __typename?: 'StudentAssignment', assignmentId: string, dueDate?: any | null, grade?: number | null, name: string, status?: Types.StudentAssignmentStatus | null }> | null } } | null };


export const StudentAssignmentsDocument = gql`
    query StudentAssignments($filters: StudentAssignmentFilterInput, $offset: Int, $limit: Int, $sort: [StudentAssignmentSortInput]) {
  currentUser {
    studentAssignments(
      filter: $filters
      limit: $limit
      offset: $offset
      sort: $sort
    ) {
      results {
        assignmentId
        dueDate
        grade
        name
        status
      }
    }
  }
}
    `;

/**
 * __useStudentAssignmentsQuery__
 *
 * To run a query within a React component, call `useStudentAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAssignmentsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useStudentAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>(StudentAssignmentsDocument, options);
      }
export function useStudentAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>(StudentAssignmentsDocument, options);
        }
// @ts-ignore
export function useStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>;
export function useStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<StudentAssignmentsQuery | undefined, StudentAssignmentsQueryVariables>;
export function useStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>(StudentAssignmentsDocument, options);
        }
export type StudentAssignmentsQueryHookResult = ReturnType<typeof useStudentAssignmentsQuery>;
export type StudentAssignmentsLazyQueryHookResult = ReturnType<typeof useStudentAssignmentsLazyQuery>;
export type StudentAssignmentsSuspenseQueryHookResult = ReturnType<typeof useStudentAssignmentsSuspenseQuery>;
export type StudentAssignmentsQueryResult = Apollo.QueryResult<StudentAssignmentsQuery, StudentAssignmentsQueryVariables>;